<template>
  <div>
    <div>
      <b-container>
        <b-row class="text-center">
          <b-col>
            <h2
              v-if="place_public_data"
              v-html="place_public_data.place.name"
            ></h2>
          </b-col>
        </b-row>

        <b-row class="text-center">
          <b-col cols="12">
            <p class="h4">Reserva Expressa - Selecione um atrativo</p>
          </b-col>
        </b-row>

        <br />
        <b-row align-h="center">
          <b-col cols="12">
            <b-carousel
              fade
              controls
              indicators
              ref="atrativosCarousel"
              :interval="form.atrativo_id != '' ? 0 : 6000"
            >
              <b-carousel-slide v-for="(atrativo, idx) in atrativos" :key="idx">
                <template #img>
                  <b-card
                    no-body
                    class="text-center card-profile listing-card-cover"
                    :img-src="atrativo.prod_image"
                    img
                    :alt="atrativo.name"
                    img-top
                    img-fluid
                  >
                    <b-row align-h="center" class="justify-content-center">
                      <b-col lg="3" class="order-lg-2">
                        <div
                          v-if="atrativo.store_logo"
                          class="card-profile-image"
                        >
                          <b-img
                            :src="atrativo.store_logo"
                            :alt="place_public_data.place.name"
                            rounded="circle"
                          />
                        </div>

                        <div v-else class="card-profile-image">
                          <b-img
                            v-bind="circleProps"
                            rounded="circle"
                            :alt="place_public_data.place.name"
                          ></b-img>
                        </div>
                      </b-col>
                    </b-row>

                    <b-card-header class="text-center border-0 pt-md-4 pb-md-4">
                      <b-row align-h="around">
                        <b-col cols="4">
                          <b-button
                            @click="chooseAtrativo(atrativo)"
                            variant="primary"
                            size="sm"
                            class="mr-4"
                            >Selecionar</b-button
                          >
                        </b-col>

                        <b-col cols="4">
                          <b-button
                            v-if="atrativo.short_description"
                            @click="mostrarInfo()"
                            variant="info"
                            size="sm"
                            class="float-right"
                            >Mais Info</b-button
                          >
                        </b-col>
                      </b-row>
                    </b-card-header>

                    <b-card-body class="pt-0">
                      <div class="text-center">
                        <h5 class="h3">{{ atrativo.name }}</h5>

                        <div
                          v-if="atrativo.description"
                          class="h5 font-weight-300"
                          v-html="atrativo.description"
                        ></div>

                        <div
                          v-if="showMoreInfo"
                          class="h5 mt-4"
                          v-html="atrativo.short_description"
                        ></div>
                      </div>
                    </b-card-body>
                  </b-card>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import useManageReservaExpressaInjection from '../../Composables/useManageReservaExpressa'

export default {
  name: 'AtrativoCarrosel',

  setup(props, context) {
    const manageReservaExpressa = useManageReservaExpressaInjection(context)

    function setTickets(items) {
      return manageReservaExpressa.setTickets(items)
    }

    return {
      setTickets,
    }
  },

  props: {
    PLACE_UUID: {
      type: String,
      default: '' | null,
    },

    atrativos: {
      type: Array | Object,
      default: [] | {},
    },

    place_public_data: {
      type: Array | Object,
      default: [] | {},
    },
  },

  data() {
    return {
      showMoreInfo: false,
      circleProps: {
        blank: true,
        blankColor: '#28a745',
        width: 75,
        height: 75,
        class: 'm1',
        border: 'dark',
      },
    }
  },

  watch: {
    atrativos(newValue, oldValue) {
      if (newValue.length == 1) {
        this.form.atrativo = newValue[0]
        this.form.atrativo_id = newValue[0].uuid
        this.form.date = moment().format('YYYY-MM-DD')
        this.form.time = ''
        this.bookingStoreCommit({
          mutation: 'SET_RESERVA_FORM',
          value: this.form,
        })
      } else if (newValue.length > 1) {
        this.form.atrativo = {}
        this.form.atrativo_id = ''
        this.form.date = moment().format('YYYY-MM-DD')
        this.form.time = ''
        this.bookingStoreCommit({
          mutation: 'SET_RESERVA_FORM',
          value: this.form,
        })
      }
    },
  },

  computed: {
    ...mapGetters('booking', {
      form: 'getReservaForm',
    }),
  },

  methods: {
    ...mapActions('booking', ['bookingStoreCommit']),

    chooseAtrativo(atrativo) {
      this.form.atrativo_id = atrativo.uuid
      this.form.atrativo = atrativo
      this.bookingStoreCommit({
        mutation: 'SET_RESERVA_FORM',
        value: this.form,
      })
      this.$emit('goToSection', 'ingressos')
    },

    mostrarInfo() {
      this.showMoreInfo = !this.showMoreInfo
    },
  },

  created() {},

  mounted() {},
}
</script>
